import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SensorsIcon from '@mui/icons-material/Sensors';
import TrafficDisruptionList from './traffic/TrafficDisruptionList';

function BusScheduleContent({
  error,
  schedule,
  fetchSchedule,
  loading,
  arrivals,
  ArrivalCard,
  getCountdown,
  t,
  currentTime,
  lineStyles,
}) {
  return (
    <>
      {error && schedule && (
        <Alert
          severity="warning"
          icon={<WarningAmberIcon />}
          action={(
            <Button color="inherit" size="small" onClick={fetchSchedule} disabled={loading}>
              {t('schedule.retry')}
            </Button>
          )}
          sx={{ mx: 1.5, mb: 0.5 }}
        >
          {t('schedule.staleWarning')}
          <Typography component="span" display="block" variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
            {error}
          </Typography>
        </Alert>
      )}

      <Stack spacing={1.25} sx={{ px: 1.5, mt: 0.5 }}>
        {schedule && schedule.realtime_available === false && (
          <Card
            elevation={2}
            sx={{
              bgcolor: 'rgba(255,255,255,0.04)',
              border: '1px dashed rgba(255,152,0,0.4)',
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ px: 2, py: 1.75 }}>
              <SensorsIcon sx={{ color: 'warning.main', fontSize: 28, opacity: 0.7 }} />
              <Box sx={{ flex: 1 }}>
                <Typography fontWeight={700} fontSize={13} color="warning.main" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  {t('schedule.realtimeUnavailable')}
                </Typography>
                <Typography fontSize={12} color="rgba(255,255,255,0.5)" sx={{ mt: 0.25 }}>
                  {t(`schedule.realtimeUnavailableDesc.${schedule.realtime_source || 'default'}`, {
                    defaultValue: t('schedule.realtimeUnavailableDesc.default'),
                  })}
                </Typography>
              </Box>
            </Stack>
          </Card>
        )}
        {arrivals.length === 0 && schedule?.realtime_available !== false ? (
          <Box sx={{ textAlign: 'center', py: 6, color: 'rgba(255,255,255,0.5)' }}>
            <Typography fontSize={40} sx={{ mb: 1.5 }}>🚏</Typography>
            <Typography>{t('schedule.noBus')}</Typography>
          </Box>
        ) : (
          arrivals.map((a, i) => (
            <ArrivalCard
              key={`${a.lineName}-${a.direction}-${a.arrivalTime}-${a.scheduledArrivalTime}-${i}`}
              arrival={a}
              isNext={i === 0 && schedule?.realtime_available}
              getCountdown={getCountdown}
              t={t}
            />
          ))
        )}
      </Stack>

      <TrafficDisruptionList
        disruptions={schedule?.disruptions || []}
        lineStyles={lineStyles}
        t={t}
      />

      <Stack direction="row" justifyContent="space-between" sx={{ px: 2, pt: 2, pb: 1 }}>
        <Typography fontSize={11} color="rgba(255,255,255,0.3)">
          {t('schedule.updatedAt', { time: currentTime.toLocaleTimeString('fr-FR', { timeZone: 'Europe/Paris' }) })}
        </Typography>
        <Typography fontSize={11} color="rgba(255,255,255,0.3)">
          {t('schedule.autoRefresh')}
        </Typography>
      </Stack>
    </>
  );
}

export default BusScheduleContent;
